export default __webpack_public_path__ + "static/media/igms.e5d29fa0.png";